export const INCREMENT = 'INCREMENT';
export const INCREMENT_SUCCESS = 'INCREMENT_SUCCESS';
export const INCREMENT_IF_ODD = 'INCREMENT_IF_ODD';
export const DECREMENT = 'DECREMENT';
export const INCREMENT_ASYNC = 'INCREMENT_ASYNC';
